import React, {Component} from 'react';

import WelcomeScreen from './screen-welcome';

import FormValidator from './form-validator';

import Input from '../../../components/input-with-label';
import RegistrationLayout from "./registration-layout";
import RegistrationFormContainer from './registration-form-container';
import PaginationNumber from "../../../components/pagination-number";

class UserDetailsScreen extends Component {

    constructor(props) {
        super(props);
        this.validator = new FormValidator([
            {
                field: 'first_name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter your First Name'
            },
            {
                field: 'last_name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter your Second Name'
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter your email address'
            },
            {
                field: 'email',
                method: 'isEmail',
                validWhen: true,
                message: 'Enter a valid email address'
            },
            {
                field: 'password',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter password'
            },
            {
                field: 'password',
                method: 'isStrongPassword',
                validWhen: true,
                message: 'Passwords must be at least 8 characters long, contain at least 1 numerical character, 1  uppercase character and 1 symbol'
            },
            {
                field: 'password_confirmation',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter password confirmation'
            },
            {
                field: 'password_confirmation',
                method: this.passwordMatch,
                validWhen: true,
                message: 'Password and password confirmation do not match'
            }
        ]);
        this.state = {
            ...props,
            validation: this.validator.valid(),
        }
        this.submitted = false;

    }
    passwordMatch = (confirmation, state) => (state.password === confirmation)

    handleChange(e) {
        this.props.onChange(e.target.name, e.target.value);
    }

    onNextClick() {

        const validation = this.validator.validate({...this.props.values});
        this.setState({validation});
        this.submitted = true;
        if(validation.isValid) {
            this.props.onNext();
        }
    }

    render() {
        const validation = this.state.validation
        const { values } = this.props;
        return(
            <RegistrationLayout
                left={<WelcomeScreen img={"/assets/grants-card.svg"} label={"Enterprising Barnsley Grants Portal"} title={"Apply for available grants with ease"} description={"Simply log in, browse, apply, and manage in one place - giving you the opportunity to support your business here in Barnsley"}/>}
                right={<RegistrationFormContainer heading='Register your account' text="Already have an account?" linkText='Sign In' linkHref='/login'>
                    <div className="registration-form__container">
                        <div className='registration-form__input-row gap'>
                            <Input label="First Name" type="text" name="first_name" placeholder="" fit={true}
                                    value={values.first_name} onChange={this.handleChange.bind(this)} errors={[validation.first_name.message]}/>
                            <Input label="Last Name" type="text" name="last_name" placeholder="" fit={true}
                                    value={values.last_name} onChange={this.handleChange.bind(this)} errors={[validation.last_name.message]}/>
                        </div>
                            <Input label="Your email address (username)" type="email" name="email" placeholder=""
                                value={values.email} onChange={this.handleChange.bind(this)} errors={[validation.email.message]}/>
                        <div className='registration-form__password-wrapper'>
                            <Input label="Password" type="password" name="password" placeholder=""
                                   value={values.password} onChange={this.handleChange.bind(this)} errors={[validation.password.message]}/>
                            {validation.password.message.length === 0 &&
                                <div className='input-outer__small'><p>Passwords must be at least 8 characters long, contain at least 1 numerical character, 1  uppercase character and 1 symbol</p></div>}

                        </div>
                            <Input label="Re-enter your password" type="password" name="password_confirmation" placeholder=""
                                value={values.password_confirmation} onChange={this.handleChange.bind(this)} errors={[validation.password_confirmation.message]}/>
                    </div>
                    <PaginationNumber currentPage={'1'} onNextClick={this.onNextClick.bind(this)}/>
                </RegistrationFormContainer>} />
        );
    }
}

export default UserDetailsScreen;
